<template>
	<div class="tree-container">
		<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
		<p>{{clickNode}}</p>
	</div>
</template>

<script type="text/javascript">
	export default {
    	data() {
      		return {
		        data: [{
		          	label: '一级 1',
		          	children: [{
			            label: '二级 1-1',
			            children: [{
			              	label: '三级 1-1-1'
			            }]
		          	}]
		        }, {
		          	label: '一级 2',
		          	children: [{
			            label: '二级 2-1',
			            children: [{
			              	label: '三级 2-1-1'
			            }]
		          	}, {
		            label: '二级 2-2',
		            children: [{
		              	label: '三级 2-2-1'
		            }]
		          	}]
		        }, {
		          	label: '一级 3',
		          	children: [{
			            label: '二级 3-1',
			            children: [{
			              	label: '三级 3-1-1'
			            }]
			        }, {
			            label: '二级 3-2',
			            children: [{
			              	label: '三级 3-2-1'
			            }]
		          	}]
		        }],
		        defaultProps: {
		          	children: 'children',
		          	label: 'label'
		        },
	      		clickNode:""
	      	}
	    },
	    methods: {
	      handleNodeClick(data) {
	        this.clickNode = data;
	      }
	    }
  	};
</script>

<style lang="less" scoped>
	.tree-container{
		padding: 25px 50px;
	}
</style>


// WEBPACK FOOTER //
// tree1.vue?1f99f9a3